import { CacheStrategy, DataSourceStrategy } from '@rammetec/data-access';
import { STOCK_COUNT_ENTRY } from '../types/stock-count.js';
/**
 * Descriptor for StockCountEntry (0116) — read via `/pg/v1`.
 * Mutated only by `/stock/counts/:id/entries`.
 */
export const stockCountEntryDescriptor = {
    name: STOCK_COUNT_ENTRY,
    label: 'Item de contagem',
    domain: 'stock',
    collectionPath: 'org/{orgId}/stock-count/{stockCountId}/entry',
    pathPatternKeys: { orgId: 'string', stockCountId: 'string' },
    version: 1,
    description: 'Counted quantity / volume reading on a stock count',
    repositoryConfig: {
        dataSource: DataSourceStrategy.PostgresRest,
        cache: CacheStrategy.InMemory,
    },
    allowedDataSources: [DataSourceStrategy.PostgresRest],
    writePolicy: 'readonly',
    fields: [
        { name: 'id', label: 'ID', type: 'string', required: true },
        { name: 'stockCountId', label: 'Contagem', type: 'string', required: true },
        { name: 'productId', label: 'Produto', type: 'string', required: true },
        { name: 'variantId', label: 'Variante', type: 'string', required: false },
        { name: 'lotId', label: 'Lote', type: 'string', required: false },
        { name: 'stockLocationId', label: 'Local', type: 'string', required: true },
        { name: 'storageAddressId', label: 'Endereço', type: 'string', required: false },
        { name: 'countedQuantity', label: 'Contado', type: 'number', required: true },
        { name: 'handlingUnitId', label: 'Volume', type: 'string', required: false },
        { name: 'countedBy', label: 'Contado por', type: 'string', required: false },
        { name: 'countedAt', label: 'Contado em', type: 'date', required: false },
        { name: 'createdAt', label: 'Criado em', type: 'date', required: false },
    ],
    foreignKeys: [
        {
            fieldName: 'productId',
            targetEntity: 'Product',
            relationship: 'many-to-one',
            displayField: 'description',
        },
        {
            fieldName: 'variantId',
            targetEntity: 'ProductVariant',
            relationship: 'many-to-one',
            displayField: 'description',
        },
        {
            fieldName: 'lotId',
            targetEntity: 'Lot',
            relationship: 'many-to-one',
            displayField: 'lotNumber',
        },
        {
            fieldName: 'stockLocationId',
            targetEntity: 'StockLocation',
            relationship: 'many-to-one',
            displayField: 'description',
        },
        {
            fieldName: 'storageAddressId',
            targetEntity: 'StorageAddress',
            relationship: 'many-to-one',
            displayField: 'code',
        },
        {
            fieldName: 'handlingUnitId',
            targetEntity: 'HandlingUnit',
            relationship: 'many-to-one',
            displayField: 'code',
        },
    ],
};
//# sourceMappingURL=stock-count-entry.descriptor.js.map